import React from 'react'
import { Box } from '@mui/material'

// A full-width banner image for a product or model on the catalog detail
// pages. Renders nothing when there is no image, so callers can pass the
// optional `image_url` straight through.
export default function CatalogBanner({ src, alt, sx }) {
  if (!src) return null

  return (
    <Box
      component="img"
      src={src}
      alt={alt || ''}
      sx={{
        display: 'block',
        width: '100%',
        maxHeight: 280,
        objectFit: 'cover',
        borderRadius: 1,
        mb: 3,
        ...sx,
      }}
    />
  )
}
